import React from 'react';
import NodeWrapper, {Title} from './NodeWrapper';

const SubFlowNode = (props) => {
  return (
    <>
      <NodeWrapper {...props}>        
        <div className='sub_flow_node'>        
          <p className='v-label'><Title title={props.data.label.substring(0,8)} /></p>
          {props.children}
        </div>
             
      </NodeWrapper>
    </>
  );
};

export default SubFlowNode;
